import { Button, Grid } from '@material-ui/core';
import { useField } from 'formik';
import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DealerQuotesStatus, FullQuotationDataFragment, PreviewUserDataFragment } from '../../../../api';
import OutlinedMultiSelectField from '../../../../components/fields/OutlinedMultiSelectField';
import useInviteQuoteData from './hooks/useInviteQuoteData';
import { useSingleButtonStyles } from './shared';

export type AuthorisationForLowerQuoteProps = {
    quotation: FullQuotationDataFragment;
    onSubmit: () => void;
    onReset: (reset: () => void) => void;
};

const AuthorisationForLowerQuote = ({ quotation, onSubmit, onReset }: AuthorisationForLowerQuoteProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage', 'common']);
    const { dealers } = useInviteQuoteData();
    const styles = useSingleButtonStyles({ desktopJustifyContent: 'flex-start' });
    const [, , { setValue }] = useField<string[]>('lowerQuoteDealerIds');
    const handleDealerSelectionChange = (selectedIds: string[]) => {
        setValue(selectedIds);
    };

    const reset = useCallback(() => {
        setValue([], false);
    }, [setValue]);

    useEffect(() => {
        onReset(reset);
    }, [onReset, reset]);
    const quotedDealerIds = new Set(
        (quotation.dealersInfo ?? [])
            .filter(dealerInfo => dealerInfo.status === DealerQuotesStatus.Quoted)
            .map(dealerInfo => dealerInfo.dealerId)
    );
    const quotedDealers = dealers.filter(
        dealer => quotedDealerIds.has(dealer.id) && quotation.entries?.some(entry => entry.dealerId === dealer.id)
    );

    return (
        <Grid container>
            <Grid xs={12} item>
                <OutlinedMultiSelectField<PreviewUserDataFragment>
                    color="secondary"
                    getOptionLabel={dealer => dealer.fullName}
                    label={t('quotation.dealerQuotes.title')}
                    name="lowerQuoteDealerIds"
                    noOptionsText={t('common:noDealers')}
                    onSelectionChange={handleDealerSelectionChange}
                    options={quotedDealers}
                    placeholder={t('common:searchDealers')}
                    renderOption={dealer => dealer.fullName}
                />
            </Grid>
            <Grid className={styles.actionButtonContainer} md={6} container item>
                <Button
                    className={styles.actionButton}
                    color="secondary"
                    onClick={onSubmit}
                    style={{ fontWeight: 'bold' }}
                    type="submit"
                    variant="outlined"
                >
                    {t('purchaseTransactionsPage:quotation.authorisationForLowerQuote.sendWANotificationToRequote')}
                </Button>
            </Grid>
        </Grid>
    );
};

export default AuthorisationForLowerQuote;
